export function temHistoricoParaVoltar(historyState = window.history?.state) {
  return Boolean(historyState && typeof historyState.idx === 'number' && historyState.idx > 0);
}

export function voltarOuDashboard(navigate, historyState = window.history?.state) {
  if (temHistoricoParaVoltar(historyState)) {
    navigate(-1);
    return;
  }

  navigate('/home');
}
